module.exports = __webpack_public_path__ + "static/media/baloon.3c5fd4d3.png";